import Swiper from 'swiper'

class Benefits {
    constructor(element) {
        this.wrapper = element
        this.slider = this.wrapper.querySelector('.swiper')
        this.sliderWrapper = this.slider.querySelector('.swiper-wrapper')
        this.swiper
        this.init()
    }

    init() {
        this.benefits(this)
    }

    benefits() {
        this.swiper = new Swiper(this.slider, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            speed: 500,
            breakpoints: {
                1024: {
                    spaceBetween: 0,
                    enabled: false
                }
            }
        })
    }
}

const benefitsSliders = document.querySelectorAll('.benefits')

benefitsSliders.forEach(slider => {
    new Benefits(slider)
})